function Footer() {
    return (
        <div>
            <footer class="text-center p-4">
                <div class="contianer">
                    <div class="row">
                        <div class="col-md-12">
                            <h5 style= {{color: "#fff",textAlign: "center"}}>© Your Website 2025. All Rights Reserved.</h5>
                            {/*style= {{property: "value",textAlign: "value"}} */}
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer;